import { createSecretKey } from "@core/foundation/token";
import type { z } from "@core/zod";

import { KEY_PREFIX } from "../../../shared/key-prefix.ts";

export const {
  generateKey: generateJobModificationKey,
  keySchema: JobModificationKeySchema,
  verifyKey: verifyJobModificationKey,
} = createSecretKey({ keyPrefix: KEY_PREFIX.JOB_MODIFICATION });

export type JobModificationKey = z.infer<typeof JobModificationKeySchema>;
